import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {FlatDocument} from '../../swagger';
import {ShrinkExpandFlatDetails} from '../ShrinkExpandFlatDetails';
import {FlatListForLogGenericState} from './FlatListForLogGenericState';
import {formatDateTime} from '../../helpers/helpers';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faChevronLeft, faChevronRight, faSearch, faTrash} from '@fortawesome/free-solid-svg-icons';
import {Badge} from '../Badge';
import {Button} from '../Button';
import {FlatDetailsStructuralActionPopover} from './FlatDetailsStructuralActionPopover';
import {RangeDateTimePicker} from '../form/RangeDateTimePicker';
import ReactJson from 'react-json-view';

export interface FlatDetailsStructuralDataProps {
    f: FlatDocument;
    state: FlatListForLogGenericState;
}

const jsonTheme = {
    scheme: 'summerfruit',
    author: 'Muscula',
    base00: '#373737',
    base01: '#202020',
    base02: '#303030',
    base03: '#505050',
    base04: '#B0B0B0',
    base05: '#D0D0D0',
    base06: '#E0E0E0',
    base07: '#FFFFFF',
    base08: '#C31010',
    base09: '#82B139',
    base0A: '#82B139',
    base0B: '#82B139',
    base0C: '#4285F4',
    base0D: '#4285F4',
    base0E: '#C31010',
    base0F: '#FFB400',
};

function objectToTree(e: object) {

}

export const FlatDetailsStructuralData: FunctionComponent<FlatDetailsStructuralDataProps> =
    observer(({f, state}) => {
        const page = state.structuralData?.page ?? 1;
        return <ShrinkExpandFlatDetails
            id={f.flatId}
            onExpand={() => state.loadStructuralData(f, 1)}
            title={'Structural data'}>
            <div className="flex bg-m-gray-3 p-2">

                {/*<div className="form-group inline">
                    <label>
                        Search
                    </label>
                    <input
                        autoComplete="off"
                        className="form-control w-40"
                        maxLength={200}
                        onChange={(e) => {
                            state.setSearchStructuralDataValue(e.target.value);
                        }}
                        onKeyPress={event => {
                            if (event.key === 'Enter') {
                                state.loadStructuralData(f, 1);
                            }
                        }}
                        placeholder={'enter field:value'}
                        value={state.structuralDataSearchValue}
                    />
                </div>*/}
                <div>
                    <label className="ml-2">
                        Filter events by time:
                    </label>
                    <RangeDateTimePicker
                        title={''}
                        onChangeDateFrom={(d) => {
                            state.setSearchStructuralCreatedDateFrom(d);
                        }}
                        onChangeDateTo={(d) => {
                            state.setSearchStructuralCreatedDateTo(d);
                        }}/>
                </div>
                <div>
                    <button
                        className="btn btn-primary mt-7 ml-4" onClick={() => state.loadStructuralData(f, 1)}>
                        <FontAwesomeIcon className="cursor-pointer" icon={faSearch}/>
                    </button>
                </div>
            </div>
            {state.structuralDataSearchArray?.length > 0 && <div className="p-2 mt-4 bg-m-gray-3">
                <label className="ml-2">
                    Filters:
                </label>
                {state.structuralDataSearchArray.map((s, i) => {
                    return <Badge key={'sdsa' + i}>{s}
                        <FontAwesomeIcon
                            className="cursor-pointer m-2" icon={faTrash}
                            onClick={() => state.toggleStructuralSearchArray(s)}/><br/></Badge>;
                })}

                {state.structuralDataSearchArray.length > 0 && <><br/>
                    <Button className="btn-primary mt-4 ml-2" onClick={() => state.toggleFlatListWithStructuralData()}>
                        {(state.listParams.searchStructuralDataFilters?.length ?? 0) > 0 && <FontAwesomeIcon icon={faCheck}/>}
                        Show all errors related to this filters
                    </Button></>}
            </div>}
            <div className="text-right">
                <span className="text-sm">Click value to filter by it</span>
                <button
                    disabled={page <= 1}
                    className="btn btn-secondary mr-px text-m-gray-6"
                    onClick={() => {
                        state.loadStructuralData(f, page - 1);
                    }}
                    title={'Previous entry'}
                >
                    <FontAwesomeIcon className="fill-current" icon={faChevronLeft}/>
                </button>
                <button
                    disabled={page >= (state.structuralData?.total ?? 0)}
                    className="btn btn-secondary ml-px mr-3 text-m-gray-6"
                    onClick={() => {
                        state.loadStructuralData(f, page + 1);
                    }}
                    title={'Next entry'}
                >
                    <FontAwesomeIcon className="fill-current" icon={faChevronRight}/>
                </button>
                <span className="font-roboto-medium text-base">
                                {page} of {state.structuralData?.total}
            </span>
            </div>
            {state.showSearchStructuralPopover &&
            <FlatDetailsStructuralActionPopover state={state}/>}

            <ul style={{listStyle: 'none'}} className="ml-2">
                {!state.structuralData?.items?.length && <span>No results</span>}
                {state.structuralData?.items?.map((s, i) => (
                    <li key={'stackelement' + i} className="p-0">
                        <div className="">
                            <h3 className="break-all text-m-green">Event time: {formatDateTime(s.created)}</h3>
                            <br/>
                            {//TODO: Dodać przetwarzanie z powrotem na drzewo, dodać obsługę przycisków
                            }
                            <ReactJson
                                theme={jsonTheme}
                                name={null}
                                enableClipboard={false}
                                quotesOnKeys={false}
                                displayDataTypes={false}
                                collapseStringsAfterLength={50}
                                onSelect={(v) => {
                                    if (typeof v.value === 'string' && v.value.length < 50 || typeof v.value === 'number') {
                                        const stringKey = v.namespace.length > 1 ? v.namespace.join('_') + '_' + v.name : v.name;
                                        state.structuralSearchPopoverSearchElement = stringKey + ':' + v.value;
                                        state.searchStructuralPopoverOpen();
                                    }
                                    if (typeof v.value === 'string' && v.value.includes('<html')) {
                                        if (confirm('Do you want to view html in separate window?')) {
                                            const stringKey = v.namespace.join('_') + '_' + v.name;
                                            const url = `/api/flats/${f.logId}/${f.flatId}/structuraldata/${s.structuralDataId}/${stringKey}`;
                                            // @ts-ignore
                                            window.open(url, '_blank').focus();
                                        }
                                    }

                                }}
                                iconStyle="circle"
                                src={state.structuralDataParsed[i]}
                                style={{padding: 10, fontSize: 10}}
                            />
                            <br/>
                        </div>
                    </li>
                ))}
            </ul>
        </ShrinkExpandFlatDetails>;
    });
